export default "__VITE_ASSET__CGCdB$Bs__"